export default "__VITE_ASSET__Cs4GGN5y__"